var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcForbidden(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 9.83317H4.83341V8.1665H13.1667M9.00008 0.666504C7.90573 0.666504 6.8221 0.882052 5.81105 1.30084C4.80001 1.71963 3.88135 2.33346 3.10752 3.10728C1.54472 4.67008 0.666748 6.7897 0.666748 8.99984C0.666748 11.21 1.54472 13.3296 3.10752 14.8924C3.88135 15.6662 4.80001 16.28 5.81105 16.6988C6.8221 17.1176 7.90573 17.3332 9.00008 17.3332C11.2102 17.3332 13.3298 16.4552 14.8926 14.8924C16.4554 13.3296 17.3334 11.21 17.3334 8.99984C17.3334 7.90549 17.1179 6.82185 16.6991 5.81081C16.2803 4.79976 15.6665 3.8811 14.8926 3.10728C14.1188 2.33346 13.2002 1.71963 12.1891 1.30084C11.1781 0.882052 10.0944 0.666504 9.00008 0.666504Z",
    fill: "#A72010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForbidden);
export default __webpack_public_path__ + "static/media/ic_forbidden.c75324fc11e47b4389243ff2ec77fc90.svg";
export { ForwardRef as ReactComponent };